/**
 * @internal
 * @param val
 */
export const valueIsDefined = (val: unknown): boolean => {
  if (val === undefined || val === null) {
    return false;
  }

  return String(val).replace(/\s/g, '').length > 0;
};
